import React from "react";
export var defaultOnboardingExpertiseLevel = {
  expertiseLevel: 'industry-expert'
};
export var OnboardingExpertiseLevelContext = React.createContext(defaultOnboardingExpertiseLevel);
export var OnboardingExpertiseLevelProvider = OnboardingExpertiseLevelContext.Provider;